import script from "./EventsRecommendation.vue?vue&type=script&setup=true&lang=js"
export * from "./EventsRecommendation.vue?vue&type=script&setup=true&lang=js"

import "./EventsRecommendation.vue?vue&type=style&index=0&id=25debb1c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25debb1c"]])

export default __exports__